import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import get from 'lodash/get';
import { priceTimerExpiredAction } from 'actions/pageActionsV4';
import PriceWidget from 'components/PriceWidget';
import CountdownTimer, { Hours, Minutes, Seconds } from 'components/Timer/Timer';
import PriceTooltip from 'widgets/ProductPageSummary/PriceTooltip/PriceTooltip';
import ProductStockUrgency from 'widgets/ProductPageSummary/ProductStockUrgency';
import StringWidget from 'components/StringWidget';
import PartPriceKnowMore from './PartPriceKnowMore';
import { numFormat } from 'utils/numFormat';
import { RUPEE_SYMBOL } from 'constants/common';
import styles from './PartPriceWidget.css';
export class PartPriceWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            preBookTimerExpired: false
        };
        this.handleTimerExpired = () => {
            this.setState({ preBookTimerExpired: true });
            this.props.priceTimerExpired();
        };
        // render pre-book deal
        this.renderPreBookDeal = () => {
            const { pricing, urgency } = this.props;
            const { preBookTimerExpired } = this.state;
            const expiryTime = get(urgency, 'expiryTime');
            const pricingValue = get(pricing, ['value']);
            return (<div className={styles['deal-info']}>
				<ProductStockUrgency urgency={urgency} containerClass={styles['deal-text']}/>

				{expiryTime && preBookTimerExpired && (<React.Fragment>
						&nbsp;
						<StringWidget strKey={'expired'} className={styles['expiry-text']}/>
					</React.Fragment>)}

				{expiryTime && !preBookTimerExpired && (<div className={styles['expiry-text']}>
						&nbsp;
						<StringWidget strKey={'endsIn'}/>
						&nbsp;
						<CountdownTimer timeRemaining={expiryTime} onExpiry={this.handleTimerExpired}>
							<Hours suffix="h : " padZeros/>
							<Minutes suffix="m : " padZeros/>
							<Seconds suffix="s" padZeros/>
						</CountdownTimer>
					</div>)}

				<div className={styles['pricing']}>
					<PriceWidget pricing={pricingValue} sellingPriceClass={styles['selling-price']} oldPriceClass={styles['old-price']} discountClass={styles['discount']} display={['selling-price', 'old-price', 'discount']}/>
					<PriceTooltip pricing={pricing} containerClass={styles['price-tooltip']}/>
				</div>
			</div>);
        };
        // render pre-order price breakup
        this.renderPriceBreakup = (partPriceInfo, knowMore) => {
            const partPrices = get(partPriceInfo, 'partPrices', []);
            if (!partPrices || partPrices.length === 0) {
                return null;
            }
            return (<div className={styles['price-breakup-details']}>
				<div className={styles['price-breakup']}>
					{partPrices.map(partPrice => (<div className={styles['price-breakup-row']}>
							<div className={styles['price']}>
								{RUPEE_SYMBOL}
								{numFormat(Number(partPrice.price))}
							</div>
							<div className={styles['text']}>{partPrice.text}</div>
						</div>))}
				</div>

				<PartPriceKnowMore handleCallBack={this.props.handleCallBack} data={knowMore} className={styles['know-more']}/>
			</div>);
        };
        // render sale price and savings
        this.renderSaleDetails = (partPriceInfo) => {
            const eventPriceCallOut = partPriceInfo.eventPriceCallOut;
            const specialCallOut = partPriceInfo.specialCallOut;
            if (!eventPriceCallOut && !specialCallOut) {
                return null;
            }
            return (<div className={styles['sale-details']}>
				<div>{this.getCalloutString(eventPriceCallOut)}</div>
				<div className={styles['pre-order-savings']}>{this.getCalloutString(specialCallOut)}</div>
			</div>);
        };
        this.getCalloutString = (callout) => {
            if (callout && callout.text) {
                const formattedPrice = numFormat(Number(callout.price));
                return callout.text.replace('%s', `${RUPEE_SYMBOL}${formattedPrice}`);
            }
        };
    }
    render() {
        const { containerClass } = this.props;
        const pricingValue = get(this.props, ['pricing', 'value']);
        const partPriceInfo = get(pricingValue, 'partPriceInfo');
        const knowMore = get(pricingValue, 'knowMore');
        if (!partPriceInfo) {
            return null;
        }
        return (<div className={cx(styles['part-price'], containerClass)}>
				{this.renderPreBookDeal()}

				{this.renderPriceBreakup(partPriceInfo, knowMore)}

				{this.renderSaleDetails(partPriceInfo)}
			</div>);
    }
}
const mapDispatchToProps = {
    priceTimerExpired: priceTimerExpiredAction
};
export default connect(null, mapDispatchToProps)(PartPriceWidget);
